define.alias("shared/components/shared/ui/accordion-item", "preview-grid/components/shared/ui/accordion-item");